<template>
  <footer>
    <div class="logo"></div>
    <div class="download-icons">
      <a target="_blank" :href="appStoreLink"><img alt="Download Wotive gym workout tracker app ios app store" src="../../assets/landing-page/appstore.svg" /></a>
      <a target="_blank" :href="googleAppStoreLink"><img alt="Download Wotive gym workout tracker app android app store" src="../../assets/landing-page/googleplay.svg" /></a>
    </div>
    <div class="links">
      <div class="links-col">
        <h3>MENU</h3>
        <a href="/promo">APP FEATURES</a>
        <a href="/about">ABOUT</a>
        <a href="/blog">BLOG</a>
      </div>
      <div class="links-col">
        <h3>SOCIAL</h3>
        <a target="_blank" href="https://www.facebook.com/wotiveapp">FACEBOOK</a>
        <a target="_blank" href="https://twitter.com/wotiveapp">TWITTER</a>
        <a target="_blank" href="https://www.instagram.com/wotiveapp">INSTAGRAM</a>
        <a target="_blank" href="https://www.youtube.com/channel/UC8BKZnZ1iYJOQrRweT4jWLQ">YOUTUBE</a>
      </div>
      <div class="links-col">
        <h3>INFO</h3>
        <a href="/terms">TERMS OF SERVICE</a>
        <a href="/privacy">PRIVACY POLICY</a>
      </div>
    </div>
    <div class="copy-right">
      © {{this.currentYear}} Wotive
    </div>
  </footer>
</template>

<script>
import { APP_STORE_LINK, GOOGLE_PLAY_STORE_LINK } from '@/constants';

export default {
  name: "Footer",

  computed: {
    appStoreLink() {
      return APP_STORE_LINK;
    },

    googleAppStoreLink() {
      return GOOGLE_PLAY_STORE_LINK;
    },

    currentYear() {
      return new Date().getFullYear();
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/assets/css/variables";

.logo {
  width: 100%;
  height: 100px;
  margin: auto;
  margin-top: 40px;
  display: flex;
  justify-content: center;
  max-width: 200px;
  min-width: 200px;
  background-image: url(~@/assets/landing-page/wotive-logo.png);
  background-repeat: no-repeat;
  background-size: contain;
  background-position: right;
}

.download-icons {
  display: none;
  img {
    height: 40px;
    margin-right: 8px;
  }
}

footer {
  background: $sec0;
  align-items: center;
  display: flex;
  flex-direction: column;

  .logo {
    height: 60px;
    width: 200px;
    background-image: url(~@/assets/landing-page/footer_logo.png);
    background-repeat: no-repeat;
    background-size: contain;
    margin-top: $spacing-base*2;
  }
  .download-icons {
    display:flex;
    margin-top: 24px;
    img {
      height: 32px;
    }
    img:first-of-type {
      margin-right: $spacing-small / 2;
    }
    img:last-of-type {
      margin-left: $spacing-small / 2;
    }
  }

  .links {
    display: flex;
    flex-direction: column;
    max-width: 1200px;
    width: 100%;
    justify-content: center;
    align-items: center;

    .links-col {
      display: flex;
      flex-direction: column;
      width: 33%;
      h3 {
        color: $sec4;
        font-weight: 700;
        font-size: 12px;
        text-align: center;
        margin: 0;
        padding-top: $spacing-small*2;
        padding-bottom: $spacing-small;
      }
      a {
        color: $sec6;
        font-weight: 400;
        font-size: 12px;
        padding-bottom: $spacing-small;
        text-align: center;
        text-decoration: none;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
  }

  .copy-right {
    margin-top: $spacing-base * 2;
    height: 30px;
    width: 100%;
    background-color: #111;
    color: $sec4;
    font-size: 12px;
    font-weight: 700;
    text-align: center;
    line-height: 30px;
  }
}

@media all and (min-width: 650px) {
  footer {
    .links {
      flex-direction: row;
      justify-content: center;
      align-items: flex-start;
    }
  }
}
</style>